import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCutlery = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.31249 15.5V8.61251C1.66667 8.46251 1.11979 8.12709 0.671869 7.60625C0.223956 7.08541 0 6.46666 0 5.75V0.5H1.24999V5.75H2.31249V0.5H3.5625V5.75H4.62501V0.5H5.87499V5.75C5.87499 6.46666 5.65104 7.08541 5.20312 7.60625C4.7552 8.12709 4.20832 8.46251 3.5625 8.61251V15.5H2.31249ZM10 15.5V9.5H7.81251V3.93749C7.81251 2.93333 8.13438 2.10938 8.77813 1.46563C9.42188 0.821875 10.2458 0.5 11.25 0.5V15.5H10Z",
		fill: "inherit"
	})
});
export default SvgCutlery;
